import { Input } from 'antd';
import styled from 'styled-components';
import { sizes } from 'theme';

export const StyledInput = styled(Input)`
    border-radius: ${sizes.radiusMd}px;
    width: 100%;

    &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled) {
        &:focus,
        &:active {
            border: 1px solid var(--brand-6);
            box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
        }

        &:hover {
            border: 1px solid var(--brand-5);
        }
    }

    &.ant-input-affix-wrapper-focused {
        border: 1px solid var(--brand-6);
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
    }

    &.ant-input-affix-wrapper-status-error {
        border: 1px solid #ff4d4f !important;
        outline: none !important;
        box-shadow: none !important;

        &:focus,
        &.ant-input-affix-wrapper-focused {
            border: 1px solid #ff4d4f !important;
            box-shadow: var(--error-box-shadow) !important;
            outline: none !important;
        }
    }

    &.ant-input-affix-wrapper-disabled,
    & input.ant-input-disabled {
        background-color: var(--gray-3) !important;
        border-color: var(--gray-5);
        color: var(--gray-6);
        cursor: not-allowed;
        box-shadow: none !important;
        opacity: 1;
    }

    &.ant-input-affix-wrapper-disabled input::placeholder {
        color: var(--gray-6);
    }

    &.ant-input-affix-wrapper-disabled:hover {
        border-color: var(--gray-5) !important;
        box-shadow: none !important;
    }
`;
